import React from 'react';
import { Paper } from 'library';
import { Provider } from 'models';
import ProviderProfileImage from './ProviderProfileImage';
import ProviderProfileActions from './actions/ProviderProfileActions';
import BusinessProviderSummary from './BusinessProviderSummary';
import FamilyProviderSummary from './FamilyProviderSummary';
import { useUserContext } from 'UserContext';

export default function ProviderSummaryCard({ provider, mobile }: { provider: Provider; mobile: boolean }) {
    const { role } = useUserContext();

    function distanceText() {
        let distance = provider.distance?.miles ?? -1;
        return distance >= 0 && distance <= 1 ? `Less than a mile away` : distance > 1 ? `${distance} miles away` : '';
    }

    return (
        <Paper
            style={{
                maxWidth: mobile ? undefined : 336,
                padding: mobile ? 10 : 20,
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: mobile ? 'row' : 'column',
                    alignItems: 'center',
                    marginTop: 10,
                }}
            >
                <ProviderProfileImage
                    provider={provider}
                    mobile={mobile}
                    showBadge={role === 'business_active' && provider.hasBCIFBICheck}
                />
                {!mobile && <ProviderProfileActions mobile={mobile} />}
                {role === 'business_active' ? (
                    <BusinessProviderSummary provider={provider} distanceText={distanceText()} mobile={mobile} />
                ) : (
                    <FamilyProviderSummary provider={provider} distanceText={distanceText()} />
                )}
            </div>
            {mobile && <ProviderProfileActions mobile={mobile} />}
        </Paper>
    );
}
